/**
 * Valid Outlook RingIds, as listed  here- https://outlookweb.visualstudio.com/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki/148/Server-Deployments?anchor=regular-deployment
 * TODO #2689038 - to be validated manually.
 * Deployment rings based on Outlook team specifications
 */ export var OutlookRingId = /*#__PURE__*/ function(OutlookRingId) {
    /** Deployment validation - Every check-in */ OutlookRingId["TDF"] = "tdf";
    /** Deployment validation - Every check-in */ OutlookRingId["PDT"] = "pdt";
    /** Inner ring - Insiders - Every check-in */ OutlookRingId["SDFv2"] = "sdfv2";
    /** Microsoft Employees - Daily deployment */ OutlookRingId["MSIT"] = "msit";
    /** MT, DONMT, GCCModerate - Every Thursday 0:30 UTC (Wednesday 16:30 PST) */ OutlookRingId["SIP"] = "sip";
    /** MT, DONMT, GCCModerate - Every Tuesday 0:30 UTC (Monday 16:30 PST) */ OutlookRingId["WW"] = "ww";
    /** ITARSIP - Every Tuesday 0:30 UTC (Monday 16:30 PST) */ OutlookRingId["ITARSIP"] = "itarsip";
    /** GALLATINSIP - Every Tuesday 0:30 UTC (Monday 16:30 PST) */ OutlookRingId["GALLATINSIP"] = "gallatinsip";
    /** AGSIP - Every Tuesday 0:30 UTC (Monday 16:30 PST) */ OutlookRingId["AGSIP"] = "agsip";
    /** GCCHigh, DoD - Every Monday 0:30 UTC (Sunday 16:30 PST) */ OutlookRingId["ITAR"] = "itar";
    /** Gallatin - Every Monday 0:30 UTC (Sunday 16:30 PST) */ OutlookRingId["Gallatin"] = "gallatin";
    /** AG08 & AG09 - Every Monday 0:30 UTC (Sunday 16:30 PST) */ OutlookRingId["AGALL"] = "agall";
    return OutlookRingId;
}({});
